/* ======================================================================
   SURFSCENT config
   ====================================================================== */
const SHOPIFY = {
  variants: {
    strawberry: 54539895308610,
    coconut:    54539895374146,
    pineapple:  54539895341378
  }
};

/* ---------------------------------------------------------------------
   >>> EDIT ME: PACK PRICING <<<
   3 is the minimum order. No singles, no 2-packs.
   `min` = the quantity at which that per-unit price kicks in.

   3–5 = $3.43 each   ·   6+ = $2.81 each

   IMPORTANT: this table only controls what the PAGE displays.
   Shopify computes the real price at checkout. You need BOTH:
     1. An automatic quantity discount at qty 6+ ($3.43 → $2.81)
        Discounts → Create → Amount off products → minimum quantity 6
     2. A 3-item minimum on the cart
        (cart validation function, or a checkout rule app)
   Set the product's base price to $3.43 so qty 3–5 needs no discount.

   Adding another tier later? Just append it here — the nudges, the price
   table, and the cart upsell all read from this array.
--------------------------------------------------------------------- */
const PRICE_TIERS = [
  { min: 3, price: 3.43 }    /* flat $3.43 each at every quantity */
];
const MIN_QTY   = 3;
const PACK_SIZE = 6;

/* Shipping: $4.99 flat under $20, FREE tracked at $20+.
   Match this in Shopify: one shipping rate $4.99 for orders $0-19.99,
   and a $0 rate for $20+. No stamp/untracked option. */
const SHIP_FEE = 4.99;
const FREESHIP_AT = 20;      /* free once subtotal hits this */
const FREESHIP_QTY = 6;      /* ...OR once you have this many fresheners */
const shipCost = (sub, qty) => (sub > 0 && sub < FREESHIP_AT && qty < FREESHIP_QTY) ? SHIP_FEE : 0;

/* Subscribe & Save: make a 10% plan in your subscription app with weekly +
   monthly frequencies (no minimum), then paste each selling-plan ID below. */
const SUB_PCT = 10;
const SUBSCRIPTION_PLANS = {
  weekly:  '692621508930',
  monthly: '692621541698'
};

const SCENTS = {
  strawberry:{name:'Strawberry',color:'#D84363'},
  coconut:{name:'Coconut',color:'#1E9C77'},
  pineapple:{name:'Pineapple',color:'#D9932E'}
};
const ORDER = ['strawberry','coconut','pineapple'];
const IMAGES = {
  strawberry:'https://cdn.shopify.com/s/files/1/0974/0478/0866/files/surfscent-strawberry.png?v=1781387412',
  coconut:'https://cdn.shopify.com/s/files/1/0974/0478/0866/files/surfscent-coconut.png?v=1781387412',
  pineapple:'https://cdn.shopify.com/s/files/1/0974/0478/0866/files/surfscent-pineapple.png?v=1781387412',
  logoDark:'https://cdn.shopify.com/s/files/1/0974/0478/0866/files/surfscent-logo-dark.png?v=1781387412',
  logoLight:'https://cdn.shopify.com/s/files/1/0974/0478/0866/files/surfscent-logo-light.png?v=1781387412'
};
const THUMBS = {};

/* ====================================================================== */

const demoMode = String(SHOPIFY.variants.strawberry).indexOf('YOUR') === 0;
document.getElementById('demoFlag').style.display = demoMode ? 'block' : 'none';
document.getElementById('yr').textContent = new Date().getFullYear();

const money = n => '$' + n.toFixed(2);
/* null-safe lookup: a single missing element must never freeze the page */
const $ = id => document.getElementById(id);
const setText = (id, v) => { const e = $(id); if(e) e.textContent = v; };
const setHTML = (id, v) => { const e = $(id); if(e) e.innerHTML = v; };
const subReady = () => String(SUBSCRIPTION_PLANS[subFreq]||'').indexOf('PASTE_') !== 0;

let cart = {};
let bundle = {strawberry:0, coconut:0, pineapple:0};
let subscribeMode = false;
let subFreq = 'monthly';

function totalQty(obj){ return Object.values(obj).reduce((a,b)=>a+b,0); }

/* ---------- tiered pricing ---------- */
function tierFor(n){
  let t = PRICE_TIERS[0];
  for(const x of PRICE_TIERS){ if(n >= x.min) t = x; }
  return t;
}
function nextTier(n){ return PRICE_TIERS.find(x => x.min > n) || null; }
/* A steep tier drop can make a bigger order CHEAPER than a smaller one
   (5 @ $3.43 = $17.15 vs 6 @ $2.81 = $16.86). Never let a customer
   silently overpay — find the upgrade and offer it. */
function cheaperUpgrade(n){
  if(n < MIN_QTY) return null;
  const here = n * tierFor(n).price;
  const t = nextTier(n);
  if(!t) return null;
  const there = t.min * t.price;
  return there < here ? {qty:t.min, total:there, saves:here-there} : null;
}
function unitFor(n){
  const base = tierFor(Math.max(n,1)).price;
  return subscribeMode ? base * (1 - SUB_PCT/100) : base;
}
function fullPrice(n){ return n * PRICE_TIERS[0].price; }

function renderTiers(n){
  const el = document.getElementById('tiers');
  if(!el) return;
  const freeNow = n >= FREESHIP_QTY;
  el.innerHTML =
    '<div class="tier'+(!freeNow&&n>0?' on':'')+'"><span class="tq">Under 6</span><span class="tp">+ '+money(SHIP_FEE)+' ship</span></div>' +
    '<div class="tier'+(freeNow?' on':'')+'"><span class="tq">6 or more</span><span class="tp">Free ship</span></div>';
}

/* ---------- the rack ---------- */
function renderRack(){
  const el = document.getElementById('rack');
  const flat = [];
  ORDER.forEach(k => { for(let i=0;i<bundle[k];i++) flat.push(k); });
  const n = flat.length;
  let html = '';
  for(let i=0;i<PACK_SIZE;i++){
    const req = (i < MIN_QTY && n < MIN_QTY) ? ' req' : '';
    if(flat[i]) html += '<div class="slot filled"><img src="'+IMAGES[flat[i]]+'" alt=""></div>';
    else html += '<div class="slot'+req+'"><span class="hook"></span></div>';
  }
  el.innerHTML = html;
  document.getElementById('rack-left').textContent =
    n===0 ? 'Three minimum · six is the sweet spot' :
    n<MIN_QTY ? ((MIN_QTY-n) + (n===MIN_QTY-1?' more to reach the minimum':' more to reach the minimum')) :
    n<PACK_SIZE ? ((PACK_SIZE-n) + (PACK_SIZE-n===1?' hook left':' hooks left')) :
    'Pack complete';
  document.getElementById('rack-over').textContent = n>PACK_SIZE ? ('+'+(n-PACK_SIZE)+' more in cart') : '';
}

/* ---------- bundle ---------- */
function bStep(key, d){ bundle[key] = Math.max(0, bundle[key] + d); renderBundle(); }
function quickAdd(key){
  bundle[key]++; renderBundle();
  document.getElementById('bundle').scrollIntoView({behavior:'smooth', block:'start'});
  toast(SCENTS[key].name + ' added to your pack');
}

function renderBundle(){
  const n = totalQty(bundle), unit = unitFor(n), sub = n*unit;
  for(const k in bundle){
    document.getElementById('b-q-'+k).textContent = bundle[k];
    document.querySelector('.b-item[data-key="'+k+'"]').classList.toggle('on', bundle[k]>0);
  }
  renderRack();
  renderTiers(n);

  document.getElementById('b-total').textContent = money(sub);

  const saved = fullPrice(n)*(subscribeMode?(1-SUB_PCT/100):1) - sub;
  document.getElementById('b-save').textContent =
    !n ? '' :
    subscribeMode ? ('save ' + SUB_PCT + '%' + (saved>0.004 ? ' + volume' : '')) :
    (saved>0.004 ? ('save ' + money(saved)) : '');

  document.getElementById('b-unit').textContent = n
    ? (n + ' freshener' + (n>1?'s':'') + ' · ' + money(unit) + ' each' + (subscribeMode?' · subscription':''))
    : 'Pick a scent to start';

  /* the buy button first — nothing may run before it and throw */
  const add = $('b-add');
  if(add){
    add.disabled = n < MIN_QTY;
    add.textContent = !n ? 'Pick 3 to start'
      : n < MIN_QTY ? ('Add ' + (MIN_QTY-n) + ' more to continue')
      : ('Add ' + n + ' · ' + money(sub));
  }

  const toFree = FREESHIP_QTY - n;   // fresheners until free shipping
  setHTML('b-nudge',
      !n ? 'Packs start at <b>3</b>. Hit <b>6</b> for free shipping.'
    : n < MIN_QTY ? ('Add <b>' + (MIN_QTY-n) + '</b> more to reach the minimum.')
    : n < FREESHIP_QTY ? ('Add <b>' + toFree + '</b> more freshener' + (toFree>1?'s':'') + ' for <b>free shipping</b>.')
    : ('Free shipping unlocked \u2014 nice.'));
}

function addBundle(){
  if(totalQty(bundle) < MIN_QTY){ toast('Packs start at 3 fresheners'); return; }
  let added = 0;
  for(const k in bundle){ if(bundle[k]>0){ cart[k]=(cart[k]||0)+bundle[k]; added+=bundle[k]; bundle[k]=0; } }
  renderBundle(); renderCart();
  if(added){ openCart(); toast(added + ' added to cart'); }
}

/* ---------- cart ---------- */
function setLine(key, qty){
  const next = {...cart};
  if(qty<=0) delete next[key]; else next[key]=qty;
  const t = totalQty(next);
  if(t>0 && t<MIN_QTY){ toast('3-freshener minimum — use “Empty cart” to clear it'); return; }
  cart = next; renderCart();
}
function clearCart(){ cart = {}; renderCart(); toast('Cart emptied'); }
function bumpTo(q){
  const n = totalQty(cart);
  if(n>=q) return;
  const k = Object.keys(cart)[0] || 'coconut';
  cart[k] = (cart[k]||0) + (q-n);
  renderCart(); toast('Added ' + (q-n) + ' · new price applied');
}

function renderCart(){
  const n = totalQty(cart), unit = unitFor(n), sub = n*unit;
  const badge = document.getElementById('cartBadge');
  badge.textContent = n; badge.style.display = n ? 'flex' : 'none';

  const lines = document.getElementById('lines');
  if(!n){
    lines.innerHTML = '<div class="empty"><b>Nothing on the hooks yet.</b>Build a pack and it lands here.</div>';
  } else {
    lines.innerHTML = Object.entries(cart).map(([k,q])=>`
      <div class="line">
        <img class="sw" src="${THUMBS[k]||IMAGES[k]}" alt="" loading="lazy">
        <div class="info"><b>${SCENTS[k].name}</b><span>${money(unit)} each${subscribeMode?' · subscription':''}</span></div>
        <div class="ls">
          <button onclick="setLine('${k}',${q-1})" aria-label="Decrease ${SCENTS[k].name}">&minus;</button>
          <span>${q}</span>
          <button onclick="setLine('${k}',${q+1})" aria-label="Increase ${SCENTS[k].name}">+</button>
        </div>
      </div>`).join('')
      + '<div class="cp-clear"><span>3-freshener minimum</span><button onclick="clearCart()">Empty cart</button></div>';
  }

  document.getElementById('d-sub').textContent = money(sub);

  /* volume upsell inside the cart */
  const up = document.getElementById('cpUpsell');
  const toFree = FREESHIP_QTY - n;
  if(n>0 && n<FREESHIP_QTY && sub<FREESHIP_AT && toFree*PRICE_TIERS[0].price <= (FREESHIP_AT-sub)){
    up.style.display = 'block';
    up.innerHTML = 'Add <b>' + toFree + ' more freshener' + (toFree>1?'s':'') + '</b> and shipping is <b>free</b>. ' +
      '<button onclick="bumpTo(' + FREESHIP_QTY + ')">Add ' + toFree + '</button>';
  } else { up.style.display = 'none'; }

  const ship = shipCost(sub, n);
  const shipEl = document.getElementById('d-ship');
  if(shipEl){
    shipEl.textContent = ship>0 ? money(ship) : 'Free · tracked';
    shipEl.classList.toggle('ship-free', ship===0);
  }
  const shipNudge = document.getElementById('d-shipnudge');
  if(shipNudge){
    if(n>0 && ship>0){
      const needQty = FREESHIP_QTY - n;            // fresheners to reach 6
      const needAmt = FREESHIP_AT - sub;           // dollars to reach $20
      // whichever is closer for the customer
      const byQty = 'Add <b>' + needQty + ' more freshener' + (needQty>1?'s':'') + '</b> to unlock <b>free shipping</b>.';
      const byAmt = 'Add <b>' + money(needAmt) + '</b> more to unlock <b>free shipping</b>.';
      shipNudge.style.display='block';
      shipNudge.innerHTML = (needQty*PRICE_TIERS[0].price <= needAmt) ? byQty : byAmt;
    } else { shipNudge.style.display='none'; }
  }
  document.getElementById('d-total').textContent = money(sub + ship);

  const saved = fullPrice(n)*(subscribeMode?(1-SUB_PCT/100):1) - sub;
  document.getElementById('d-save').textContent = !n ? ''
    : subscribeMode ? ('Subscribe & Save ' + SUB_PCT + '% · ' + subFreq + ' · cancel anytime')
    : saved>0.004 ? ('You save ' + money(saved))
    : '';

  document.getElementById('cpCheckout').textContent = subscribeMode
    ? ('Start subscription · save ' + SUB_PCT + '%')
    : 'Continue to secure checkout';

  document.getElementById('mb-total').textContent = money(sub + shipCost(sub, n));
  document.getElementById('mb-count').textContent = n + (n===1?' item':' items') + (n>0 ? ' · ' + money(unit) + ' each' : '');
  document.getElementById('mbar').classList.toggle('show', n>0);
  document.body.classList.toggle('mbar-on', n>0);

  renderBundle();
}

function openCart(){ const c=document.getElementById('cartpage'); c.classList.add('show'); c.setAttribute('aria-hidden','false'); c.scrollTop=0; document.body.classList.add('cart-open'); }
function closeCart(){ const c=document.getElementById('cartpage'); c.classList.remove('show'); c.setAttribute('aria-hidden','true'); document.body.classList.remove('cart-open'); }
document.getElementById('cartBtn').addEventListener('click', openCart);
document.addEventListener('keydown', e => { if(e.key==='Escape') closeCart(); });

/* ---------- modes ---------- */
function setMode(m){ subscribeMode=(m==='sub');
  document.getElementById('bm-once').classList.toggle('on',!subscribeMode);
  document.getElementById('bm-sub').classList.toggle('on',subscribeMode);
  document.getElementById('subFreq').style.display = subscribeMode ? 'grid' : 'none';
  renderCart(); }
function setFreq(f){ subFreq=f;
  document.getElementById('sf-weekly').classList.toggle('on',f==='weekly');
  document.getElementById('sf-monthly').classList.toggle('on',f==='monthly');
  renderCart(); }

/* ---------- checkout (Shopify cart link — no API token) ---------- */
function checkout(){
  const n = totalQty(cart);
  if(!n){ toast('Your cart is empty'); return; }
  if(n < MIN_QTY){ toast('Packs start at 3 fresheners'); return; }
  const entries = Object.entries(cart).filter(([k,q]) => q>0);
  if(subscribeMode){
    if(!subReady()){ toast('Subscriptions aren\u2019t connected yet — finish setup in Shopify'); return; }
    const add = '/cart/add?' + entries.map(([k,q]) => 'items[][id]='+SHOPIFY.variants[k]+'&items[][quantity]='+q+'&items[][selling_plan]='+SUBSCRIPTION_PLANS[subFreq]).join('&') + '&return_to=/checkout';
    toast('Starting your subscription…');
    window.location.href = '/cart/clear?return_to=' + encodeURIComponent(add);
  } else {
    const items = entries.map(([k,q]) => SHOPIFY.variants[k]+':'+q);
    toast('Taking you to checkout…');
    window.location.href = '/cart/' + items.join(',');
  }
}

/* ---------- misc ---------- */
function signup(){
  const v = document.getElementById('emailIn').value.trim();
  if(!v || v.indexOf('@')<0){ toast('Enter a valid email'); return; }
  toast('Thanks! Connect your email tool to capture sign-ups.');
  document.getElementById('emailIn').value='';
}
let toastT;
function toast(msg){ const el=document.getElementById('toast'); el.textContent=msg; el.classList.add('show'); clearTimeout(toastT); toastT=setTimeout(()=>el.classList.remove('show'),2600); }

if(location.search.indexOf('contact_posted=true')>-1) toast('Thanks — we\u2019ll be in touch!');
document.querySelectorAll('[data-img]').forEach(el=>{ if(IMAGES[el.dataset.img]) el.src=IMAGES[el.dataset.img]; });

renderCart();